import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { actions as notification } from '@skunexus/notification';
import { Spinner } from '@skunexus/component-catalog';
import { useDivisions } from '../hooks/useDivisions';

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
    errorNotification: notification.error,
    successNotification: notification.success,
};

export const withLocationsByProductGridCustom = () => (Component) => {
    function WrappedComponent(props) {
        const { errorNotification } = props;
        const [{ isFetching = false, divisions = [] } = {}, { fetchDivisions }] = useDivisions({ errorNotification });

        const customGridData = (gridProps) => {
            return {
                ...gridProps,
                filters: [
                    {
                        label: 'Division',
                        field: 'stocks.division',
                        type: 'multi_select',
                        options: [...divisions],
                    },
                    ...(gridProps.filters || []).map((filter) => {
                        if (filter?.field === 'stocks.sku') {
                            return {
                                ...filter,
                                field: 'stocks.sku_list',
                                type: 'tags',
                            };
                        }

                        return filter;
                    }),
                ],
            };
        };

        useEffect(() => {
            fetchDivisions();
        }, []);

        if (isFetching) {
            return (
                <div>
                    <Spinner size="sm" />
                </div>
            );
        }

        return <Component {...props} customGridData={customGridData} />;
    }

    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
};
